import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "jspdf-autotable";
import { handleGetRequest } from "../../services/GetTemplate";
import { FaCheckCircle, FaExclamationCircle, FaSpinner } from "react-icons/fa";
import styled from "styled-components";
import { Button } from "primereact/button";

const StyledIcon = styled.div`
  color: ${(props) => props.color};
`;

const FileStatusSummaryReport = ({ fileHeadId }) => {

  const [loading, setloading] = useState(false);
  const [fileStausDetailsData, setfileStausDetailsData] = useState([]);

  const getFileStatus = async () => {
    setloading(true);
    const res = await handleGetRequest(
      "zbizgateway/fileStatusCheck/fileUploadStatusDetail/" + fileHeadId
    );
    setfileStausDetailsData(res?.data);
    setloading(false);
  };

  const STATUS_CONFIG = {
    I: {
      color: "orange",
      icon: <FaSpinner />,
      text: "In Progress",
    },
    S: {
      color: "green",
      icon: <FaCheckCircle />,
      text: "Success",
    },
    E: {
      color: "red",
      icon: <FaExclamationCircle />,
      text: "Error",
    },
    P: {
      color: "green",
      icon: <FaCheckCircle />,
      text: "Processed",
    },
  };

  const statusBodyTemplate = (rowData) => {
    const config = STATUS_CONFIG[rowData?.statusCode];

    if (!config) return null;

    return (
      <StyledIcon color={config.color}>
        {config.icon} {config.text}
      </StyledIcon>
    );
  };

  useEffect(() => {
    if (fileHeadId !== null) {
      getFileStatus();
    }
  }, [fileHeadId]); // eslint-disable-line

  if (fileHeadId === null) {
    return null;
  }

  const exportExcel = () => {
    import('xlsx').then(xlsx => {

      // Define the columns to export and their new names
      const columnMapping = {
        employeeName: 'Employee Name',
        titleFetchStatus: 'T24 Status',
        employeeCnic: 'Employee Cnic',
        employeeAccountNo: 'Employee Account Number',
        accountNoStatus: 'Account No Status',
        amount: 'Amount',
        transactionCode: 'Transaction Id',
        createdate: 'Transaction Created Date',
        statusDescr: 'Status',
      };

      // Map the data to include only the specified columns with new names
      const exportData = fileStausDetailsData.map(item => {
        let obj = {};
        Object.keys(columnMapping).forEach(key => {
          obj[columnMapping[key]] = item[key];
        });
        return obj;
      });

      // Convert the mapped data to a worksheet
      const worksheet = xlsx.utils.json_to_sheet(exportData && exportData);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

      // Save the Excel file
      saveAsExcelFile(excelBuffer, 'File Status Summary');
    });
  }

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    });
  }

  const header = (
    <div
      className="flex justify-content-center"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <p>File Status Detail</p>
      <Button
        label="Export Excel"
        type="button"
        icon="pi pi-file-excel"
        onClick={exportExcel}
        className="p-button-success p-mr-2"
        data-pr-tooltip="XLS"
      />
    </div>
  );

  return (
    <>
      <DataTable
        header={header}
        value={fileStausDetailsData}
        // selectionMode="multiple"
        // metaKeySelection={false}
        // selection={selectedFiles}
        // onSelectionChange={(e) => setSelectedFiles(e.value)}
        scrollable
        scrollHeight="400px"
        style={{ minWidth: "50rem" }}
        tableStyle={{ minWidth: "120rem" }}
        dataKey="fileDetailId"
        loading={loading}
        paginator
        rows={10}
        emptyMessage="No data found."
      >
        {/* <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column> */}
        {/* <Column filter field="chequeNo" header="Cheque No" /> */}
        {/* <Column filter field="companyName" header="Company Name" /> */}
        {/* <Column filter field="t24AccountNo" header="T24 Account No" /> */}
        {/* <Column filter field="t24AccountTitle" header="T24 Account Title" /> */}
        <Column filter field="employeeName" header="Employee Name" />
        <Column filter field="titleFetchStatus" header="T24 Status" />
        {/* <Column filter field="nameStatus" header="Name Status" /> */}
        <Column filter field="employeeCnic" header="Employee CNIC" />
        {/* <Column filter field="cnicStatus" header="CNIC Status" /> */}
        <Column filter field="employeeAccountNo" header="Employee Account No" />
        <Column filter field="accountNoStatus" header="Account No Status" />
        <Column filter field="amount" header="Amount" />
        {/* <Column filter field="segment" header="Segment" /> */}
        <Column filter field="transactionCode" header="Transaction ID" />
        <Column filter field="createdate" header="Transaction Create Date" />
        {/* <Column
          filter
          field="statusCode"
          filterField={(rowData) =>
            rowData?.statusCode === "I"
              ? "In Progress"
              : rowData?.statusCode === "S"
                ? "Success"
                : rowData?.statusCode === "E"
                  ? "Error"
                  : rowData?.statusCode === "P"
                    ? "Processed"
                    : null
          }
          header="Status"
          body={statusBodyTemplate}
          filterMatchMode="contains"
        /> */}
        <Column filter field="statusDescr" header="Status Description" />
      </DataTable>
    </>
  );
};

export default FileStatusSummaryReport;
